import {
    HttpErrorResponse,
    HttpInterceptorFn,
    HttpResponse,
} from "@angular/common/http";
import { Provider } from "@Front-end/seed/models/provider";
import { SearchResult } from "@Front-end/seed/models/search";
import {
    catchError,
    map,
    Observable,
    throwError,
} from "rxjs";
import { sportBrandId } from "../../constants/sporting.constants";

export const sportbookProviderInterceptor: HttpInterceptorFn = (request, next) => {
    const providersUrl: string = "game/brand/list";
    const searchUrl: string = "/search";
    const brandId: number = sportBrandId;

    return next(request).pipe(
        map((event) => {
            if (
                event instanceof HttpResponse
                && event.status === 200
                && (event.body as { result: unknown })?.result
                && request.url.includes(providersUrl)
            ) {
                const updatedBrands: Provider[] = (<Provider[]> (event.body as { result: unknown }).result)
                    .filter((item: Provider) => item.brand_id !== brandId);
                event = event.clone({ body: { ...(event.body as { result: unknown }), result: updatedBrands } });
            }

            if (
                event instanceof HttpResponse
                && event.status === 200
                && (event.body as { brands: unknown })?.brands
                && request.url.includes(searchUrl)
            ) {
                const updatedBrands: Provider[] = (<Provider[]> (event.body as {
                    brands: { result: unknown }
                }).brands.result)
                    .filter((item: Provider) => item.brand_id !== brandId);
                const updatedResult: SearchResult = {
                    // @ts-ignore
                    ...event.body,
                    brands: {
                        // @ts-ignore
                        ...event.body.brands,
                        result: updatedBrands,
                    },
                };
                event = event.clone({
                    // @ts-ignore
                    body: { ...event.body, ...updatedResult },
                });
            }

            return event;
        }),
        catchError((error: HttpErrorResponse): Observable<never> => throwError(() => error)),
    );
};
